import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Typography } from 'ck-ui';
import { ProductListingPageContext } from '../context';

class FacetContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: !props.forceOpen,
      isMenu: !!props.menu,
    };
  }

  componentDidMount = () => {
    // Close facets by default on mobile
    if (window.innerWidth >= 768) {
      this.setState({
        isCollapsed: !this.props.menu, // keep menu open on desktop only
      });
    }
  };

  toggleFacet = () => {
    const { isCollapsed } = this.state;
    this.setState({ isCollapsed: !isCollapsed });
  };

  render = () => {
    const { isCollapsed, isMenu } = this.state;
    const { label, refinedCount, render, forceOpen, forceRender } = this.props;
    return (
      <ProductListingPageContext.Consumer>
        {({ isMobile }) => (
          <div className={classnames('facet', {
            'facet-open': forceOpen || !isCollapsed,
            'facet-menu': isMenu
          })}
          >
            {label ? (
              <div
                className="facet-heading"
                role="menuitem"
                tabIndex="0"
                onClick={this.toggleFacet}
              >
                <Typography
                  display="inline"
                  color="black-bis"
                  variant={isMobile ? 'body-medium' : 'body-large'}
                  capitalize
                  weight={500}
                  className={classnames('facet-heading-title', { 'mobile-facet-heading-title': isMobile })}
                >
                  {label}
                </Typography>
                {refinedCount > 0 && (
                  <span className="facet-heading-counter"> ({refinedCount})</span>
                )}
                {isCollapsed ? (
                  <div className="facet-heading-icon">
                    <Icon name="plus" size="small" />
                  </div>
                ) : (
                  <div className="facet-heading-icon">
                    <Icon name="minus" size="small" />
                  </div>
                )}
              </div>
            ) : null}
            <div className="facet-content">
              {(!isCollapsed || forceRender) && render(this.state)}
            </div>
          </div>
        )}
      </ProductListingPageContext.Consumer>
    );
  };
}

FacetContainer.propTypes = {
  forceOpen: PropTypes.bool,
  refinedCount: PropTypes.number,
  label: PropTypes.string,
  menu: PropTypes.bool,
  render: PropTypes.func.isRequired,
  forceRender: PropTypes.bool
};

FacetContainer.defaultProps = {
  forceOpen: false,
  label: null,
  refinedCount: 0,
  menu: false,
  forceRender: false
};

export { FacetContainer };
